import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-legal-mentions',
  templateUrl: './legal-mentions.component.html',
  styleUrls: ['./legal-mentions.component.scss']
})
export class LegalMentionsComponent implements OnInit {

  constructor(
    @Inject(MAT_DIALOG_DATA) public data,
    public dialogRef: MatDialogRef<LegalMentionsComponent>
  ) { }
  ngOnInit(): void {
    this.dialogRef.disableClose = true;
  }  

  onNoClick(): void {
    this.dialogRef.close();
  }  
}
